/* eslint-disable max-lines */
import { Abi, Address, zeroAddress } from 'viem'

import { STAKED_USDE_V2_ABI, USDE_ABI, USDT_ABI } from '../constants/abi'
import { TokenType } from '../types'

import { IS_PROD_ENV } from './is-production'

const USDE_ADDRESS = IS_PROD_ENV
  ? '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'
  : '0x2dFaF238B8255826A160432126E0BC5db20c33e9'

// stETH serves as mock token in UAT for testing purposes
const STETH_ADDRESS = IS_PROD_ENV
  ? '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84'
  : '0xe90eC12369FbbCBCDaAa320DA59134281458D16B'

const ENA_ADDRESS = process.env.NEXT_PUBLIC_IS_SENA_TESTING
  ? '0x1CdeF1eE3f3b170c5c5FF7c252a9a017B2E4E3C8'
  : '0x57e114B691Db790C35207b2e685D4A43181e6061'

const sENA_ADDRESS = process.env.NEXT_PUBLIC_IS_SENA_TESTING
  ? '0x661ED445C389315A60e1931BAd0B6Fa22e6D519c'
  : '0x8bE3460A480c80728a8C4D7a5D5303c85ba7B3b9'

export const TOKEN_ADDRESSES: Record<TokenType, Address> = {
  AaveLidoSusde: '0xc2015641564a5914A17CB9A92eC8d8feCfa8f2D0',
  AeUSDe: '0x4B0821e768Ed9039a70eD1E80E15E76a5bE5Df5F',
  AeUSDeAug2025: '0x5F9190496e0DFC831C3bd307978de4a245E2F5cD',
  'Ambient USDe • ETH': zeroAddress,
  'Angle USDa': '0x0000206329b97db379d5e1bf586bbdb969c63274',
  APTeUSDe: '0x2eDff5AF94334fBd7C38ae318edf1c40e072b73B',
  APTsUSDe: '0xDE6eF6CB4aBd3A473ffC2942eEf5D84536F8E864',
  APTUSDe: '0x312ffC57778CEfa11989733e6E08143E7E229c1c',
  ASUSDe: '0x4579a27aF00A62C0EB156349f31B345c08386419',
  AUSD: zeroAddress,
  AUSDe: '0x4F5923Fc5FD4a93352581b38B7cD26943012DECF',
  'Avalon USDa': '0x8A60E489004Ca22d775C5F2c657598278d17D9c2',
  BBUSD: zeroAddress,
  BTC: zeroAddress,
  cmETH: zeroAddress,
  'Cooldown USDe': '0x7FC7c91D556B400AFa565013E3F32055a0713425',
  crvUSD: '0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E',
  'Curve USDe • USDT': '0x5b03cccab7ba3010fa5cad23746cbf0794938e96',
  DAI: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
  DOLA: zeroAddress,
  dUSD: '0x788D96f655735f52c676A133f4dFC53cEC614d4A',
  ENA: ENA_ADDRESS,
  ETH: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  'Ether.fi Liquid': '0x08c6F91e2B681FaF5e17227F2a44C307b3C1364C',
  eUSD: '0x939778D83b46B456224A33Fb59630B11DEC56663',
  eUSDe: '0xae703b505f9284cf0eC2E9A907637238EF5d9b11',
  FDUSD: '0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409',
  feUSD: '0x02c6a2fA58cC01A18B8D9E00eA48d65E4dF26c70',
  FRAX: '0x853d955aCEf822Db058eb8505911ED77F175b99e',
  FRAXFraxtal: '0xfc00000000000000000000000000000000000001',
  frxUSD: '0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29',
  GHO: '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f',
  GYD: '0xe07f9d810a48ab5c3c914ba3ca53af14e4491e8a',
  iUSD: zeroAddress,
  liUSD: zeroAddress,
  LlamaThena: '0x72eD19788Bce2971A5ed6401662230ee57e254B7',
  'Locked ENA': zeroAddress,
  mETH: '0xd5F7838F5C461fefF7FE49ea5ebaF7728bB0ADfa',
  mkUSD: '0x4591DBfF62656E7859Afe5e45f6f47D3669fBB28',
  'MOE USDe • AUSD': zeroAddress,
  'MOE USDe • cmETH': zeroAddress,
  'MOE USDe • mETH': '0x74Db2EB31D4B5a0522d3c2eB6dBd87aAc21745f9',
  'MOE USDe • sUSDe': zeroAddress,
  'MOE USDe • USDC': zeroAddress,
  'MOE USDe • USDT': '0x7bC5Cd04Dd1211a445444dfda6aE11Af27367a2c',
  'Morpho Wrapped LP eUSDe': zeroAddress,
  'Morpho Wrapped LP sUSDe': zeroAddress,
  ONyc: zeroAddress,
  'PT ENA': '0x9946c55a34cd105f1e0cf815025eaecff7356487',
  'PT ENA OCT': '0xAfA002De2DADb57B2b04e32aa4F42a69AdEBF2FD',
  'PT eUSDe': zeroAddress,
  'PT rsENA': '0x74fd29b63766e9d05ed9d1181a365522d096ed6f',
  'PT sUSDe': zeroAddress,
  'PT USDe': zeroAddress,
  PTUSDeJuly: '0xa0021EF8970104c2d008F38D92f115ad56a9B8e1',
  pUSDe: zeroAddress,
  RateX: zeroAddress,
  reUSD: '0x5086bf358635B81D8C47C66d1C8b9E567Db70c72',
  reUSDe: '0xdDC0f880ff6e4e22E4B74632fBb43Ce4DF6cCC5a',
  rsENA: '0xc65433845ecD16688eda196497FA9130d6C47Bd8',
  rsUSDe: '0x82f5104b23FF2FA54C2345F821dAc9369e9E0B26',
  scrvUSD: '0x0655977feb2f289a4ab78af67bab0d17aab84367',
  sDAI: '0x83F20F44975D03b1b09e64809B757c47f942BEeA',
  sENA: sENA_ADDRESS,
  sFRAX: '0xe3b3fe7bca19ca77ad877a5bebab186becfad906',
  sfrxUSD: '0xcf62f905562626cfcdd2261162a51fd02fc9c5b6',
  siUSD: zeroAddress,
  SolvBTC: zeroAddress,
  stETH: STETH_ADDRESS,
  sUSD: '0x57Ab1ec28D129707052df4dF418D58a2D46d5f51',
  sUSDe: '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
  'sUSDe • crvUSD': zeroAddress,
  'sUSDe • DOLA': '0x744793B5110f6ca9cC7CDfe1CE16677c3Eb192ef',
  'sUSDe • dUSD': '0xF16f226Baa419d9DC9D92C040CCBC8c0E25F36D7',
  'sUSDe • feUSD': '0xC2E5B3bd2C630D803b0b5A0BcFAD5f51B651F375',
  'sUSDe • FRAX Fraxtal': '0x8b4e5263e8d6cc0bbf31edf14491fc6077b88229',
  'sUSDe • GHO': zeroAddress,
  'sUSDe • GHO • USDC': zeroAddress,
  'sUSDe • GYD': zeroAddress,
  'sUSDe • HONEY': zeroAddress,
  'sUSDe • PYUSD': zeroAddress,
  'sUSDe • scrvUSD': '0xd29f8980852c2c76fc3f6e96a7aa06e0bedcc1b1',
  'sUSDe • sDAI': '0x167478921b907422F8E88B43C4Af2B8BEa278d3A',
  'sUSDe • sDAI • sFRAX': zeroAddress,
  'sUSDe • sFRAX': zeroAddress,
  'sUSDe • sfrxUSD': '0x3BD1017929b43c1414bE2Aca39892590fBa4d6e2',
  'sUSDe • siUSD': zeroAddress,
  'sUSDe • sUSD': '0x4b5E827F4C0a1042272a11857a355dA1F4Ceebae',
  'sUSDe • sUSDs': '0x3cef1afc0e8324b57293a6e7ce663781bbefbb79',
  'sUSDe • USDB': zeroAddress,
  'sUSDe • USDC': zeroAddress,
  'sUSDe • USDC • USDT': zeroAddress,
  'sUSDe • USDC.e': zeroAddress,
  'sUSDe • USDe': '0x35d5854E6697396129395Ba0a41149d4057174C2',
  'sUSDe • USDT': zeroAddress,
  'sUSDe • USDT • USDC': zeroAddress,
  'sUSDe • USDT • USDT': zeroAddress,
  'sUSDe • wstETH': zeroAddress,
  sUSDeFraxtal: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
  sUSDs: '0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD',
  'Tempest USDe • ETH': zeroAddress,
  'Terminal tUSDe': zeroAddress,
  tsUSDe: zeroAddress,
  tUSDe: zeroAddress,
  USDB: '0x4300000000000000000000000000000000000003',
  USDC: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  USDe: USDE_ADDRESS,
  'USDe • crvUSD': '0xF55B0f6F2Da5ffDDb104b58a60F2862745960442',
  'USDe • DAI': '0xF36a4BA50C603204c3FC6d2dA8b78A7b69CBC67d',
  'USDe • eUSDe': zeroAddress,
  'USDe • FDUSD': '0xF8dB2ACcdEf8e7a26b0E65C3980ADC8ce11671a4',
  'USDe • feUSD': '0xAA00BF46394774938922E282f6C4B07F5059651F',
  'USDe • FRAX': '0x5dc1BF6f1e983C0b21EfB003c105133736fA0743',
  'USDe • FRAX Fraxtal': '0x1e199dbe1f7aa237282fe941d5bcc3b167c8ce48',
  'USDe • frxUSD': '0xdBb1d219d84eaCEFb850ee04caCf2f1830934580',
  'USDe • GHO': '0x670a72e6D22b0956C0D2573288F82DCc5d6E3a61',
  'USDe • HONEY': zeroAddress,
  'USDe • iUSD': zeroAddress,
  'USDe • mkUSD': '0x1ab3D612EA7df26117554ddDD379764EBcE1A5Ad',
  'USDe • NECT': zeroAddress,
  'USDe • PYUSD': zeroAddress,
  'USDe • sUSD': '0x59a06b97b2d566B9Dee2a368EaC8787Cfa57f95D',
  'USDe • sUSDS': zeroAddress,
  'USDe • USDa': '0x68984391a8ce6203067ee65ff7eed38c7e0d2d88',
  'USDe • USDB': zeroAddress,
  'USDe • USDC': '0x02950460E2b9529D0E00284A5fA2d7bDF3fA4d72',
  'USDe • USDC Arbitrum': '0x1c34204FCFE5314Dcf53BE2671C02c35DB58B4e3',
  'USDe • USDC • USDT': zeroAddress,
  'USDe • USDC.e': zeroAddress,
  'USDe • USDT': '0x435664008F38B0650fBC1C9fc971D0A3Bc2f1e47',
  'USDe • USDT • USDT': zeroAddress,
  'USDe • USDT0': '0xC8819A6cE017139CceB5710b44be104667187A7C',
  'USDe • USDtb': '0x2D9Bf9C1beFd77C094461df615bdbE905895f7C6',
  'USDe • USDtb • GHO': zeroAddress,
  'USDe • USDtb • USDC': zeroAddress,
  'USDe • USDtb • USDT': zeroAddress,
  'USDe • USDX': '0x096a8865367686290639bc50bf8d85c0110d9fea',
  'USDe • USH': '0x3Bee53e887D52d9CBa177396AA44810904D501fF',
  'USDe • waGHO': zeroAddress,
  USDeFraxtal: '0x5d3a1ff2b6bab83b63cd9ad0787074081a52ef34',
  USDT: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  USDT0: '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb',
  USDtb: '0xC139190F447e929f090Edeb554D95AbB8b18aC1C',
  USDX: '0xb2F30A7C980f052f02563fb518dcc39e6bf38175',
  USH: zeroAddress,
  waGHO: '0xd9fba68d89178e3538e708939332c79efc540179',
  WBETH: '0xa2E3356610840701BDf5611a53974510Ae27E2e1',
  WETH: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
}

export const TOKEN_SYMBOLS: Record<TokenType, string> = {
  AaveLidoSusde: 'aEthLidosUSDe',
  AeUSDe: 'AeUSDe',
  AeUSDeAug2025: 'AeUSDe',
  'Ambient USDe • ETH': 'AmbientUSDeETH',
  'Angle USDa': 'AngleUSDa',
  APTeUSDe: 'APTeUSDe',
  APTsUSDe: 'APTsUSDe',
  APTUSDe: 'APTUSDe',
  ASUSDe: 'ASUSDe',
  AUSD: 'AUSD',
  AUSDe: 'AUSDe',
  'Avalon USDa': 'AvalonUSDa',
  BBUSD: 'BBUSD',
  BTC: 'BTC',
  cmETH: 'cmETH',
  'Cooldown USDe': 'Cooldown USDe',
  crvUSD: 'crvUSD',
  'Curve USDe • USDT': 'CurveUSDeUSDT',
  DAI: 'DAI',
  DOLA: 'DOLA',
  dUSD: 'dUSD',
  ENA: 'ENA',
  ETH: 'ETH',
  'Ether.fi Liquid': 'liquidUSD',
  eUSD: 'eUSD',
  eUSDe: 'eUSDe',
  FDUSD: 'FDUSD',
  feUSD: 'feUSD',
  FRAX: 'FRAX',
  FRAXFraxtal: 'FRAXFraxtal',
  frxUSD: 'frxUSD',
  GHO: 'GHO',
  GYD: 'GYD',
  iUSD: 'iUSD',
  liUSD: 'liUSD',
  LlamaThena: 'LlamaThena',
  'Locked ENA': 'Locked ENA',
  mETH: 'mETH',
  mkUSD: 'mkUSD',
  'MOE USDe • AUSD': 'MOEUSDeAUSD',
  'MOE USDe • cmETH': 'MOEUSDecmETH',
  'MOE USDe • mETH': 'MOEUSDemETH',
  'MOE USDe • sUSDe': 'MOEUSDesUSDe',
  'MOE USDe • USDC': 'MOEUSDeUSDC',
  'MOE USDe • USDT': 'MOEUSDeUSDT',
  'Morpho Wrapped LP eUSDe': 'LPeUSDe',
  'Morpho Wrapped LP sUSDe': 'LPsUSDe',
  ONyc: 'ONyc',
  'PT ENA': 'PTENA',
  'PT ENA OCT': 'PTENAOCT',
  'PT eUSDe': 'PTeUSDe',
  'PT rsENA': 'PTrsENA',
  'PT sUSDe': 'PTsUSDe',
  'PT USDe': 'PTUSDe',
  PTUSDeJuly: 'USDe',
  pUSDe: 'pUSDe',
  RateX: 'RateX',
  reUSD: 'reUSD',
  reUSDe: 'reUSDe',
  rsENA: 'rsENA',
  rsUSDe: 'rsUSDe',
  scrvUSD: 'scrvUsd',
  sDAI: 'sDAI',
  sENA: 'sENA',
  sFRAX: 'sFRAX',
  sfrxUSD: 'sfrxUSD',
  siUSD: 'siUSD',
  SolvBTC: 'SolvBTC',
  stETH: 'stETH',
  sUSD: 'sUSD',
  sUSDe: 'sUSDe',
  'sUSDe • crvUSD': 'sUSDeCrvUSD',
  'sUSDe • DOLA': 'sUSDeDola',
  'sUSDe • dUSD': 'sUSDeDusd',
  'sUSDe • feUSD': 'sUSDeFeusd',
  'sUSDe • FRAX Fraxtal': 'sUSDEFRAXFraxtal',
  'sUSDe • GHO': 'sUSDeGho',
  'sUSDe • GHO • USDC': 'sUSDeGhoUsdc',
  'sUSDe • GYD': 'sUSDeGYD',
  'sUSDe • HONEY': 'sUSDeHONEY',
  'sUSDe • PYUSD': 'sUSDePYUSD',
  'sUSDe • scrvUSD': 'sUSDeScrvusd',
  'sUSDe • sDAI': 'sUSDeSdai',
  'sUSDe • sDAI • sFRAX': 'sUSDeSdaiSfrax',
  'sUSDe • sFRAX': 'sUSDeSfrax',
  'sUSDe • sfrxUSD': 'sUSDeSfrxUSD',
  'sUSDe • siUSD': 'sUSDeSiUSD',
  'sUSDe • sUSD': 'sUSDeSUSD',
  'sUSDe • sUSDs': 'sUSDeSUSDs',
  'sUSDe • USDB': 'sUSDeUsdb',
  'sUSDe • USDC': 'sUSDeUsdc',
  'sUSDe • USDC • USDT': 'sUSDeUsdcUsdt',
  'sUSDe • USDC.e': 'sUSDeUsdc.e',
  'sUSDe • USDe': 'sUSDeUSDe',
  'sUSDe • USDT': 'sUSDeUsdt',
  'sUSDe • USDT • USDC': 'sUSDeUsdtUsdc',
  'sUSDe • USDT • USDT': 'sUSDeUsdtUsdt',
  'sUSDe • wstETH': 'sUSDeWsteth',
  sUSDeFraxtal: 'sUSDeFraxtal',
  sUSDs: 'sUSDs',
  'Tempest USDe • ETH': 'TempestUSDeETH',
  'Terminal tUSDe': 'tUSDe',
  tsUSDe: 'tsUSDe',
  tUSDe: 'tUSDe',
  USDB: 'USDB',
  USDC: 'USDC',
  USDe: 'USDe',
  'USDe • crvUSD': 'USDecrvUSD',
  'USDe • DAI': 'USDeDAI',
  'USDe • eUSDe': 'USDeEUSDe',
  'USDe • FDUSD': 'USDeFDUSD',
  'USDe • feUSD': 'USDeFeUSD',
  'USDe • FRAX': 'FRAXUSDe',
  'USDe • FRAX Fraxtal': 'USDeFRAXFraxtal',
  'USDe • frxUSD': 'USDeFrxUSD',
  'USDe • GHO': 'GHOUSDe',
  'USDe • HONEY': 'USDeHONEY',
  'USDe • iUSD': 'USDeiUSD',
  'USDe • mkUSD': 'mkUSDUSDe',
  'USDe • NECT': 'USDeNECT',
  'USDe • PYUSD': 'USDePYUSD',
  'USDe • sUSD': 'sUSD',
  'USDe • sUSDS': 'USDeSUSDS',
  'USDe • USDa': 'USDeUSDa',
  'USDe • USDB': 'USDeUSDB',
  'USDe • USDC': 'USDeUSDC',
  'USDe • USDC Arbitrum': 'USDEUSDC',
  'USDe • USDC • USDT': 'USDeUsdcUsdt',
  'USDe • USDC.e': 'USDeUSDC.e',
  'USDe • USDT': 'USDeUSDT',
  'USDe • USDT • USDT': 'USDeUsdtUsdt',
  'USDe • USDT0': 'USDeUSDT0',
  'USDe • USDtb': 'USDeUSDtb',
  'USDe • USDtb • GHO': 'USDeUSDtbGho',
  'USDe • USDtb • USDC': 'USDeUSDtbUsdc',
  'USDe • USDtb • USDT': 'USDeUSDtbUsdt',
  'USDe • USDX': 'USDeUSDX',
  'USDe • USH': 'USDeUSH',
  'USDe • waGHO': '',
  USDeFraxtal: 'USDeFraxtal',
  USDT: 'USDT',
  USDT0: 'USDT0',
  USDtb: 'USDtb',
  USDX: 'USDX',
  USH: 'USH',
  waGHO: 'waGHO',
  WBETH: 'wBETH',
  WETH: 'WETH',
}

export const TOKENS_BY_ADDRESS: Record<Address, TokenType> = Object.entries(TOKEN_ADDRESSES).reduce(
  (a, c) => ({ ...a, [c[1]]: c[0] }),
  {},
)

export const TOKEN_ICONS: Record<TokenType, string | string[]> = {
  AaveLidoSusde: 'shared/sUSDe.svg',
  AeUSDe: 'eusde.svg',
  AeUSDeAug2025: 'eusde.svg',
  'Ambient USDe • ETH': ['shared/usde.svg', 'ethereum.svg'],
  'Angle USDa': 'usda-angle.svg',
  APTeUSDe: 'eusde.svg',
  APTsUSDe: 'shared/sUSDe.svg',
  APTUSDe: 'shared/usde.svg',
  ASUSDe: 'shared/sUSDe.svg',
  AUSD: 'ausd.png',
  AUSDe: 'shared/usde.svg',
  'Avalon USDa': 'usda-avalon.svg',
  BBUSD: 'bbusd.png',
  BTC: 'btc.webp',
  cmETH: 'cmeth.png',
  'Cooldown USDe': 'shared/USDe.svg',
  crvUSD: 'crvUSD.png',
  'Curve USDe • USDT': ['shared/usde.svg', 'usdt.png'],
  DAI: 'dai.webp',
  DOLA: 'dola.png',
  dUSD: 'dusd.png',
  ENA: 'shared/ethena.svg',
  ETH: 'ethereum.svg',
  'Ether.fi Liquid': 'etherfi-liquid.png',
  eUSD: 'shared/eusd.svg',
  eUSDe: 'eusde.svg',
  FDUSD: 'fdusd.svg',
  feUSD: 'feusd.png',
  FRAX: 'frax.svg',
  FRAXFraxtal: 'frax.svg',
  frxUSD: 'frxusd.png',
  GHO: 'gho.png',
  GYD: 'gyd.png',
  iUSD: 'siusd.png',
  liUSD: 'siusd.png',
  LlamaThena: ['shared/sUSDe.svg', 'scrvusd.png'],
  'Locked ENA': 'locked-ena.svg',
  mETH: 'meth.webp',
  mkUSD: 'mkUSD.png',
  'MOE USDe • AUSD': ['shared/usde.svg', 'ausd.png'],
  'MOE USDe • cmETH': ['shared/usde.svg', 'cmeth.png'],
  'MOE USDe • mETH': ['shared/usde.svg', 'meth.webp'],
  'MOE USDe • sUSDe': ['shared/usde.svg', 'shared/sUSDe.svg'],
  'MOE USDe • USDC': ['shared/usde.svg', 'usdc.png'],
  'MOE USDe • USDT': ['shared/usde.svg', 'usdt.png'],
  'Morpho Wrapped LP eUSDe': 'eusde.svg',
  'Morpho Wrapped LP sUSDe': 'shared/sUSDe.svg',
  ONyc: 'onre.png',
  'PT ENA': 'shared/ethena.svg',
  'PT ENA OCT': 'shared/ethena.svg',
  'PT eUSDe': 'eusde.svg',
  'PT rsENA': 'shared/rsENA.svg',
  'PT sUSDe': 'shared/sUSDe.svg',
  'PT USDe': 'shared/usde.svg',
  PTUSDeJuly: 'shared/usde.svg',
  pUSDe: 'pusde.svg',
  RateX: 'ratex.svg',
  reUSD: 're.png',
  reUSDe: 're.png',
  rsENA: 'shared/rsENA.svg',
  rsUSDe: 'shared/rsUSDe.svg',
  scrvUSD: 'scrvusd.png',
  sDAI: 'sdai.png',
  sENA: 'shared/sENA.svg',
  sFRAX: 'frax.svg',
  sfrxUSD: 'sfrxusd.png',
  siUSD: 'siusd.png',
  SolvBTC: 'solvbtc.png',
  stETH: 'lido.png',
  sUSD: 'shared/susd.png',
  sUSDe: 'shared/sUSDe.svg',
  'sUSDe • crvUSD': ['shared/sUSDe.svg', 'crvUSD.png'],
  'sUSDe • DOLA': ['shared/sUSDe.svg', 'dola.png'],
  'sUSDe • dUSD': ['shared/sUSDe.svg', 'dusd.png'],
  'sUSDe • feUSD': ['shared/sUSDe.svg', 'feusd.png'],
  'sUSDe • FRAX Fraxtal': ['shared/sUSDe.svg', 'frax.svg'],
  'sUSDe • GHO': ['shared/sUSDe.svg', 'gho.png'],
  'sUSDe • GHO • USDC': ['shared/sUSDe.svg', 'gho.png', 'usdc.png'],
  'sUSDe • GYD': ['shared/sUSDe.svg', 'gyd.png'],
  'sUSDe • HONEY': ['shared/sUSDe.svg', 'honey.png'],
  'sUSDe • PYUSD': ['shared/sUSDe.svg', 'pyusd.png'],
  'sUSDe • scrvUSD': ['shared/sUSDe.svg', 'scrvusd.png'],
  'sUSDe • sDAI': ['shared/sUSDe.svg', 'sdai.png'],
  'sUSDe • sDAI • sFRAX': ['shared/sUSDe.svg', 'sdai.png', 'frax.svg'],
  'sUSDe • sFRAX': ['shared/sUSDe.svg', 'frax.svg'],
  'sUSDe • sfrxUSD': ['shared/sUSDe.svg', 'sfrxusd.png'],
  'sUSDe • siUSD': ['shared/sUSDe.svg', 'siusd.png'],
  'sUSDe • sUSD': ['shared/sUSDe.svg', 'shared/susd.png'],
  'sUSDe • sUSDs': ['shared/sUSDe.svg', 'susds.png'],
  'sUSDe • USDB': ['shared/sUSDe.svg', 'usdb.svg'],
  'sUSDe • USDC': ['shared/sUSDe.svg', 'usdc.png'],
  'sUSDe • USDC • USDT': ['shared/sUSDe.svg', 'usdc.png', 'usdt.png'],
  'sUSDe • USDC.e': ['shared/sUSDe.svg', 'usdc.png'],
  'sUSDe • USDe': ['shared/sUSDe.svg', 'shared/usde.svg'],
  'sUSDe • USDT': ['shared/sUSDe.svg', 'usdt.png'],
  'sUSDe • USDT • USDC': ['shared/sUSDe.svg', 'usdt.png', 'usdc.png'],
  'sUSDe • USDT • USDT': ['shared/sUSDe.svg', 'usdt.png'],
  'sUSDe • wstETH': ['shared/sUSDe.svg', 'wsteth.png'],
  sUSDeFraxtal: '/shared/sUSDe.svg',
  sUSDs: 'susds.png',
  'Tempest USDe • ETH': ['shared/usde.svg', 'ethereum.svg'],
  'Terminal tUSDe': 'terminal-tusde.png',
  tsUSDe: 'shared/sUSDe.svg',
  tUSDe: 'shared/usde.svg',
  USDB: 'usdb.svg',
  USDC: 'usdc.png',
  USDe: 'shared/usde.svg',
  'USDe • crvUSD': ['shared/usde.svg', 'crvUSD.png'],
  'USDe • DAI': ['shared/usde.svg', 'dai.webp'],
  'USDe • eUSDe': ['shared/usde.svg', 'eusde.svg'],
  'USDe • FDUSD': ['shared/usde.svg', 'fdusd.svg'],
  'USDe • feUSD': ['shared/usde.svg', 'feusd.png'],
  'USDe • FRAX': ['shared/usde.svg', 'frax.svg'],
  'USDe • FRAX Fraxtal': ['shared/usde.svg', 'frax.svg'],
  'USDe • frxUSD': ['shared/usde.svg', 'frxusd.png'],
  'USDe • GHO': ['shared/usde.svg', 'gho.png'],
  'USDe • HONEY': ['shared/usde.svg', 'honey.png'],
  'USDe • iUSD': ['shared/usde.svg', 'siusd.png'],
  'USDe • mkUSD': ['shared/usde.svg', 'mkUSD.png'],
  'USDe • NECT': ['shared/usde.svg', 'nect.jpg'],
  'USDe • PYUSD': ['shared/usde.svg', 'pyusd.png'],
  'USDe • sUSD': ['shared/usde.svg', 'shared/susd.png'],
  'USDe • sUSDS': ['shared/usde.svg', 'susds.png'],
  'USDe • USDa': ['shared/usde.svg', 'usda-avalon.svg'],
  'USDe • USDB': ['shared/usde.svg', 'usdb.svg'],
  'USDe • USDC': ['shared/usde.svg', 'usdc.png'],
  'USDe • USDC Arbitrum': ['shared/usde.svg', 'usdc.png'],
  'USDe • USDC • USDT': ['shared/usde.svg', 'usdc.png', 'usdt.png'],
  'USDe • USDC.e': ['shared/usde.svg', 'usdc.png'],
  'USDe • USDT': ['shared/usde.svg', 'usdt.png'],
  'USDe • USDT • USDT': ['shared/usde.svg', 'usdt.png'],
  'USDe • USDT0': ['shared/usde.svg', 'shared/usdt0.png'],
  'USDe • USDtb': ['shared/usde.svg', 'shared/usdtb.svg'],
  'USDe • USDtb • GHO': ['shared/usde.svg', 'shared/usdtb.svg', 'gho.png'],
  'USDe • USDtb • USDC': ['shared/usde.svg', 'shared/usdtb.svg', 'usdc.png'],
  'USDe • USDtb • USDT': ['shared/usde.svg', 'shared/usdtb.svg', 'usdt.png'],
  'USDe • USDX': ['shared/usde.svg', 'usdx.png'],
  'USDe • USH': ['shared/usde.svg', 'ush.png'],
  'USDe • waGHO': ['shared/usde.svg', 'wagho.png'],
  USDeFraxtal: '/shared/usde.svg',
  USDT: 'usdt.png',
  USDT0: 'shared/usdt0.png',
  USDtb: 'shared/usdtb.svg',
  USDX: 'usdx.png',
  USH: 'ush.png',
  waGHO: 'wagho.png',
  WBETH: 'wbeth.png',
  WETH: 'weth.png',
}

export const TOKEN_DECIMALS: Record<string, number> = {
  'Ether.fi Liquid': 6,
  tsUSDe: 6,
  tUSDe: 6,
  USDC: 6,
  USDT: 6,
}

export const TOKEN_ABI: Record<string, Abi> = {
  sENA: STAKED_USDE_V2_ABI,
  sUSDe: STAKED_USDE_V2_ABI,
  USDe: USDE_ABI,
  USDT: USDT_ABI,
}

export const METH_YIELD = 3.1
